import { CustomerInfo } from '@interfaces/interfaces';

export const user: CustomerInfo = { firstname: '', lastname: '' };
